import Button from '@/decodo/components/atoms/Button';
import Heading from '@/decodo/components/atoms/Heading';
import { Text } from '@/decodo/components/atoms/Text';
import { useTranslation } from '@/lib/i18n/i18n.client';

import IconFaceSad from '~/icons/face-sad.svg';

type ErrorPageProps = {
  onSubmit: () => void;
};

export function ErrorPage({ onSubmit }: ErrorPageProps) {
  const { texts } = useTranslation();

  return (
    <div className='flex flex-col items-start justify-center md:h-full lg:items-center'>
      <div className='mb-6 flex w-full items-center justify-start gap-4 lg:justify-center'>
        <IconFaceSad className='text-error-500 h-8 w-8' />
        <Heading level='h3'>
          {texts.contact_sales.error.something_went_wrong}
        </Heading>
      </div>
      <Text
        color='gray-dark-500'
        classNames={{ wrapper: 'mb-9 lg:text-center' }}
      >
        {texts.contact_sales.error.message_decodo}
      </Text>
      <Button
        onClick={onSubmit}
        classNames={{ root: 'lg:w-auto w-full lg:min-w-[320px]' }}
      >
        {texts.contact_sales.error.try_again}
      </Button>
    </div>
  );
}
